import { Injectable } from '@angular/core';
import { CollectionQuery, DataService } from '../data.service';
import { DataPathsService } from '../data-paths.service';
import { switchMap, first, map } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { DataEnvService } from '../data-env.service';
import { SlServicesService } from '../../sl-services/sl-services.service';
import moment from 'moment';
import { CarrierMessageListDoc, MessageDoc, NotificationDoc } from './messages-types';
import firebase from 'firebase/compat/app';

@Injectable({
    providedIn: 'root'
}) 
export class MessagesData {

    constructor(
        private dataCtrl: DataService,
        private dataPaths: DataPathsService,
        private services: SlServicesService,
        private dataEnv: DataEnvService
    ) { }

    //TODO: accept a parameter for last N days, which defaults to 5
    public latestChatMessages$(carrierId: string, limit: number = 5) : Observable<MessageDoc[]> {
        return this.dataPaths.carrierMessages$(carrierId)
            .pipe(
                switchMap(path => this.dataCtrl.getCollection$<CarrierMessageListDoc>({
                    path,
                    orderBy: "date", orderDirection: "desc",
                    limit
                })),
                map(res => {
                    const flatMessages: MessageDoc[] = [];
                    res.forEach((messageOfDay) => {
                        flatMessages.push(...messageOfDay.messages);
                    });
                    return flatMessages;
                })
            );
    }

    public notifications$ = combineLatest([this.dataPaths.notifications$, this.dataEnv.selectedHub$])
    .pipe(
        switchMap(([path, selectedHub])=>this.dataCtrl.getCollection$<NotificationDoc>({ 
            path, 
            queries: [
                selectedHub ? ['hub', '==', selectedHub] : null,
                ['created_at', '>', firebase.firestore.Timestamp.fromDate(moment().subtract(7, 'days').toDate())]
            ].filter(Boolean) as CollectionQuery }))
    );

    public async removeAllNotifications(authorType: 'client' | 'driver' | '' = '') {
        const selectedHub = await this.dataEnv.selectedHub$.pipe(first()).toPromise();
        return await this.services.callService(`removeAllNotifications`, { authorType, hub: selectedHub });
    }

    public async removeNotification(id: string) {
        const selectedHub = await this.dataEnv.selectedHub$.pipe(first()).toPromise();
        return await this.services.callService(`removeNotification`, { id, hub: selectedHub });
    }
}
